import { BsChevronDown } from "react-icons/bs";
import { useSpring, animated, config } from "@react-spring/web";
import { useClickAway } from "react-use";
import { useDashboard } from "../../providers/dashboard";
import { useRef, useState } from "react";

const Dropdown = () => {
    const { state, dispatch } = useDashboard();

    const [isOpen, setIsOpen] = useState(false);

    const chevronSpring = useSpring({
        config: config.stiff,
        rotate: isOpen ? "-180deg" : "0deg"
    })

    const ref = useRef()
    useClickAway(ref, () => {
        setIsOpen(false)
    })

    return (
        <div
            className="relative cursor-pointer"
            ref={ref}
        >
            <p
                className="text-lg"
            >
                Vælg bil
            </p>
            <div
                className="py-3 px-5 shadow-md bg-skgBlue rounded-md text-white"
            >
                {
                    state.cars[state.selectedCar]
                        ? (
                            <div
                                className="flex items-center justify-between"
                                onClick={() => setIsOpen(p => !p)}
                            >
                                <div>
                                    {
                                        state.cars[state.selectedCar].vehicle_make + " " + state.cars[state.selectedCar].vehicle_model
                                    }
                                </div>
                                <animated.span
                                    style={chevronSpring}
                                >
                                    <BsChevronDown />
                                </animated.span>
                            </div>
                        )
                        : (
                            <div>
                                Ingen bil
                            </div>
                        )
                }
            </div>
            {
                isOpen && (
                    <div
                        className="absolute w-full"
                    >
                        {
                            state.cars
                                .map((car, idx) => {
                                    if (idx !== state.selectedCar) {
                                        return (
                                            <div
                                                onClick={() => {
                                                    dispatch({
                                                        key: "selectedCar",
                                                        value: idx
                                                    })
                                                    setIsOpen(false)
                                                }}
                                                className="bg-[#f4f4f4] mt-2 rounded-md shadow-md mx-3 p-3 hover:bg-skgBlue hover:text-white transition-all"
                                            >
                                                {car.vehicle_make + " " + car.vehicle_model}
                                            </div>
                                        )
                                    }
                                })
                        }
                    </div>
                )
            }
        </div>
    )
}

export default Dropdown;